import React, { useRef, useLayoutEffect } from 'react';
import ReadingSelectModal from './ReadingSelectModal';
import { SlideObject } from '../../../types';

interface SlideObjectReadingProps {
  interactable: boolean;
  modalManager: ModalManager;
  slideObject: SlideObject;
}

const SlideObjectReading = ({ interactable, modalManager, slideObject }: SlideObjectReadingProps) => {
  const iframeRef = useRef(null);

  // Add styles to the iframe if it exists.
  useLayoutEffect(() => {
    if (iframeRef.current && iframeRef.current.getElementsByTagName('iframe')[0]) {
      if (slideObject.borderWidth) {
        iframeRef.current.getElementsByTagName('iframe')[0].classList.remove('!tw-border-0');
      }

      const iframeStyle = iframeRef.current.getElementsByTagName('iframe')[0].style;
      const styles = {
        backgroundColor: slideObject.backgroundColor ? `${slideObject.backgroundColor}` : '',
        borderColor: slideObject.borderColor ? `${slideObject.borderColor}${slideObject.borderOpacity}` : '',
        borderRadius: slideObject.borderRadius ? `${slideObject.borderRadius}px` : '',
        borderWidth: slideObject.borderWidth ? `${slideObject.borderWidth}px` : '',
        opacity: slideObject.opacity ? `${slideObject.opacity}` : '',
        padding: slideObject.padding ? `${slideObject.padding}px` : '',
      };

      Object.assign(iframeStyle, styles);
    }
  }, []);

  return (
    <>
      <div
        ref={iframeRef}
        dangerouslySetInnerHTML={{ __html: slideObject.html }}
      />
      {interactable && (
        <ReadingSelectModal modalManager={modalManager} slideObject={slideObject} />
      )}
    </>
  );
};

export default SlideObjectReading;
